import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormGroup,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Switch from "react-switch"
import { Offsymbol, OnSymbol } from "util/switchButtonUtil"
// import CustomSelect from "../../components/CustomSelect/customSelect"
// import MultiSelectSort from "components/SortableSelect/SortableSelect"
import _ from "lodash"
import ValidatorForm, { TextField, MultiSelect } from "../ValidatorForm"
import Select from "react-select"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import { LANGUAGES, PERMISSIONS_ARRAY } from "../../constants/uiConstants"
import "./styles.css"
export default class AddUserForm extends ErrorBoundComponent {
  state = {
    formData: {},
    appCode: this.props.appCode,
    status:
      this.props && this.props.data && this.props.data.status == 0
        ? false
        : true,
    userTypeOptions: [
      //{ label: "Super Admin", value: 1,disabled: this.props.currentUser.userType > 1 },
      // { label: "Admin", value: 2, disabled: this.props.currentUser.userType > 1},
      { label: "Content Manager", value: 3 }, // Create Update Challem, audio and content
      { label: "Moderator", value: 4 }, // Requires permissions to be updated in the users table and same reads to be handled at routes
      { label: "Ads Ops", value: 6 }, // For source Type and sponsor text in challenge and audio
      { label: "Internal Moderator", value: 7 },
    ],
    agency: null,
    customStyles: {
      option: (provided, state) => ({
        ...provided,
        color: "black",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
      }),
    },
  }

  componentDidMount() {
    const { permissionList = [], roleData = [], emailList = [] } = this.props
    const permissionArray = []
    permissionList.map((item, idx) => {
      let label = item.permissionId.split("_").toString()
      let permissionObj = {
        label: label.replaceAll(",", " "),
        value: item.permissionId,
      }
      permissionArray.push(permissionObj)
    })
    const rolesArray = []
    roleData.map((item, idx) => {
      let roleObj = {
        label: (
          <div>
            {item.roleName}{" "}
            <i className="fas fa-info-circle" title={item.permissions}></i>
          </div>
        ),
        value: item.roleCode,
      }
      rolesArray.push(roleObj)
    })
    const emailArray = []
    emailList.map((item, idx) => {
      let emailObj = {
        label: item.email,
        value: item.email,
      }
      emailArray.push(emailObj)
    })

    this.setState({ permissionArray, rolesArray, emailArray })
  }

  _handleFieldChange = (val, field) => {
    let formData = this.state.formData
    if (field === "email") {
      formData[field] = val.value
    } else {
      const valArray = val.map(element => {
        return element.value
      })
      formData[field] = valArray
    }
    this.setState({
      formData,
    })
  }

  _getDefaultValues = (roles, field) => {
    // let applicationsData = applications.filter((item) => item.applicationCode === this.state.appCode);
    // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
    // let rolesArr = !_.isEmpty(filteredApp) ? (filteredApp["roles"] && filteredApp["roles"].length > 0 ?  filteredApp["roles"] : []) : [];
    let array = []
    let roleOrPermissionArr = []
    switch (field) {
      case "roles":
        roleOrPermissionArr = this.state.rolesArray
        break
      case "includePermission":
      case "excludePermission":
        roleOrPermissionArr = this.state.permissionArray
        break
    }
    roleOrPermissionArr.forEach(item => {
      if (roles.includes(item.value)) {
        array.push(item)
      }
    })
    return array
  }

  _form = () => {
    const { permissionList = [] } = this.props

    const filterdPermissions = PERMISSIONS_ARRAY.map(permission => {
      if (
        permission.value === "UPDATE_USER_AGENCY" &&
        !this.props.currentUser?.jotRoles?.includes("SUPER_ADMIN")
      ) {
        return { ...permission, disabled: true }
      } else {
        return permission
      }
    })
    // const permissionArray =  [];
    // const filterdPermissions = permissionList.map((item, idx) => {
    //   let label = (item.permissionId.split("_")).toString();
    //   let permissionObj = {
    //     label: label.replaceAll(",", " "),
    //     value: item.permissionId
    //   }
    //   permissionArray.push(permissionObj);
    //   // return permissionArray;
    // })
    // const permissionArray = [
    //   ...PERMISSIONS_ARRAY,
    //   // {
    //   //   label: "Internal QC Tag Content",
    //   //   value: "INTERNAL_QC_TAG_CONTENT",
    //   //   disabled:
    //   //     this.props.currentUser.agency ||
    //   //     (this.props.currentUser.agency &&
    //   //       !this.props.currentUser.agency.includes("INTERNAL")),
    //   // },
    //   {
    //     label: "Tag Content Admin",
    //     value: "TAG_CONTENT_ADMIN",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    //   {
    //     label: "Community Manager",
    //     value: "COMMUNITY_MANAGER",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    //   {
    //     label: "View Real Stats",
    //     value: "VIEW_REAL_STATS",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    //   {
    //     label: "Manage CMS Users",
    //     value: "MANAGE_CMS_USERS",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    // ];
    return (
      <React.Fragment>
        <Col>
          <Card>
            <CardTitle className="p-3 pb-0">
              {this.props.formAction === "create" ? "Add User" : "Update User"}
            </CardTitle>
            <CardBody>
              <AvForm onValidSubmit={(e, values) => this._onSubmit(values)}>
                <Row>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="email" className="col-lg-2">
                        Email
                      </Label>
                      <Select
                        styles={this.state.customStyles}
                        isMulti={false}
                        onChange={val => this._handleFieldChange(val, "email")}
                        defaultValue={
                          this.props.data &&
                          this.props.data.email && [
                            {
                              label: this.props.data.email,
                              value: this.props.data.email,
                            },
                          ]
                        }
                        options={this.state.emailArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col>
                  {/* {this.props.formAction === "create" && (
                                        <Col lg="12">
                                            <FormGroup className="mb-2">
                                                <Label htmlFor="password" className="col-lg-2">
                                                    Password
                                                </Label>
                                                <AvField
                                                    name="password"
                                                    type="password"
                                                    placeholder="Password"
                                                    errorMessage="Enter password"
                                                    autoComplete="off"
                                                    validate={{
                                                        required: {
                                                            value: this.props.formAction === "create" ? true : false,
                                                        },
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    )} */}
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="roles">Roles</Label>
                      <Select
                        styles={this.state.customStyles}
                        isMulti={true}
                        onChange={val => this._handleFieldChange(val, "roles")}
                        defaultValue={
                          this.props.data &&
                          this.props.data.roles &&
                          this._getDefaultValues(this.props.data.roles, "roles")
                        }
                        options={this.state.rolesArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="jotPermissions">Add Permissions</Label>
                      <Select
                        styles={this.state.customStyles}
                        isMulti={true}
                        onChange={val =>
                          this._handleFieldChange(val, "includePermission")
                        }
                        defaultValue={
                          this.props.data &&
                          this.props.data.includePermission &&
                          this._getDefaultValues(
                            this.props.data.includePermission,
                            "includePermission"
                          )
                        }
                        options={this.state.permissionArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="jotRevokedPermissions">
                        Revoke Permissions
                      </Label>
                      <Select
                        styles={this.state.customStyles}
                        isMulti={true}
                        onChange={val =>
                          this._handleFieldChange(val, "excludePermission")
                        }
                        defaultValue={
                          this.props.data &&
                          this.props.data.excludePermission &&
                          this._getDefaultValues(
                            this.props.data.excludePermission,
                            "excludePermission"
                          )
                        }
                        options={this.state.permissionArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6">
                    <FormGroup className="mb-2">
                      <Label htmlFor="userStatus" className="col-lg-4">
                        Status
                      </Label>
                      <Col lg="10">
                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8 mb-2"
                          onColor="#626ed4"
                          onChange={() =>
                            this.setState({ status: !this.state.status })
                          }
                          checked={this.state.status}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                  {/* <Col lg="6">
                  <FormGroup className="mb-2">
                    <Label htmlFor="roles" className="col-lg-2">
                      Roles
                    </Label>
                    <Select
                      isMulti={true}
                      onChange={val => _setJotRoles(val)}
                      // defaultValue={
                      //   props.data &&
                      //   props.data.jotRoles &&
                      //   props.data.jotRoles.map(role => {
                      //     return { label: role, value: role }
                      //   })
                      // }
                      options={roles}
                      isOptionDisabled={option => option.disabled}
                    />
                  </FormGroup>
                </Col> */}
                  {/* <Col lg="6">
                  <FormGroup className="mb-2">
                    <Label htmlFor="agency" className="col-lg-2">
                      Desk Type
                    </Label>
                    <Select
                      type="select"
                      name=""
                      value={deskType}
                      onChange={value => {
                        setSourceType(value.value)
                        _handleDeskTypeChange(value)
                      }}
                      options={deskTypeOptions}
                    />
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup className="mb-2">
                    <Label htmlFor="sourceId" className="col-lg-2">
                      Sources
                    </Label>
                    <MultiSelectSort
                      options={availableSource}
                      onChange={value => {
                        setSources(value)
                      }}
                      disabled={!deskType}
                      value={sources}
                    />
                  </FormGroup>
                </Col>
                {sourceType && (
                  <Col lg="6">
                    <FormGroup className="mb-2">
                      <Label htmlFor="userStatus" className="col-lg-6">
                        Delete <b>{sourceType}</b> Desk
                      </Label>
                      <Col lg="10">
                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8 mb-2"
                          onColor="#626ed4"
                          onChange={() => setDeleteDesk(!deleteDesk)}
                          checked={deleteDesk}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                )}

                // <Col lg="6">
                //   <FormGroup className="mb-2">
                //     <Label htmlFor="userStatus" className="col-lg-2">
                //       Status
                //     </Label>
                //     <Col lg="10">
                //       <Switch
                //         uncheckedIcon={<Offsymbol />}
                //         checkedIcon={<OnSymbol />}
                //         className="me-1 mb-sm-8 mb-2"
                //         onColor="#626ed4"
                //         onChange={() => setSwitch(!switch1)}
                //         checked={switch1}
                //       />
                //     </Col>
                //   </FormGroup>
                </Col> */}
                </Row>
                <div className="d-flex justify-content-end">
                  <Button type="submit" color="primary" className="mx-2">
                    {this.props.formAction === "create" ? "Create" : "Update"}
                  </Button>
                  <Button color="danger" onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
      // <Row>
      //   <Col lg={12}>
      //     <Card>
      //       <CardBody>
      //         <ValidatorForm>
      //           <div className="row mb-4">
      //             <Label
      //               htmlFor="horizontal-firstname-Input"
      //               className="col-sm-3 col-form-label"
      //             >
      //               First name
      //             </Label>
      //             <Col sm={9} lg={12}>
      //               <Input
      //                 type="text"
      //                 className="form-control"
      //                 id="horizontal-firstname-Input"
      //                 required
      //               />
      //             </Col>
      //           </div>
      //           <div className="row mb-4">
      //             <Label
      //               htmlFor="horizontal-email-Input"
      //               className="col-sm-3 col-form-label"
      //             >
      //               Email
      //             </Label>
      //             <Col sm={9} lg={12}>
      //               <Input
      //                 type="email"
      //                 className="form-control"
      //                 id="horizontal-email-Input"
      //               />
      //             </Col>
      //           </div>
      //           <div className="row mb-4">
      //             {/* <Label
      //               htmlFor="horizontal-firstname-Input"
      //               className="col-sm-3 col-form-label"
      //             >
      //               Agency
      //             </Label> */}
      //             <Col sm={9} lg={12}>
      //             {/* <MultiSelect
      //               label={"Languages"}
      //               placeholderLabel="Languages"
      //               field={"languages"}
      //               className="creator-form"
      //               defaultValue=""
      //               options={LANGUAGES.map(lang => {
      //                 return { label: lang.label, value: lang.value }
      //               })}
      //               validations={["requiredArr"]}
      //               errors={["This field is required"]}
      //             /> */}
      //               {/* <Select
      //                 mode="multiple"
      //                 showSearch
      //                 allowClear={true}
      //                 placeholder="Language"
      //                 // defaultValue={props.filters["languages"]}
      //                 onChange={value => {
      //                   props.handleFilterChange(value, "languages")
      //                 }}
      //                 style={{ width: "100%" }}
      //               >
      //                 <Option value="">All</Option>
      //                 {LANGUAGES.map(lang => (
      //                   <Option value={lang.value}>{lang.label}</Option>
      //                 ))}
      //               </Select> */}
      //               {/* <select defaultValue="0"  className="form-select form-select-lg" size={1} multiple>
      //                   <option value="0">Choose...</option>
      //                   <option value="1">One</option>
      //                   <option value="2">Two</option>
      //                   <option value="3">Three</option>
      //                 </select> */}
      //               <Select
      //                 placeholderLabel="Agency"
      //                 disabled={this.props.formAction === "update"}
      //                 field="agency"
      //                 allowClear={true}
      //                 className="creator-form"
      //                 // defaultValue={this.props.data && this.props.data.agency ? this.props.data.agency : null}
      //                 // value={this.props.data && this.props.data.agency ? this.props.data.agency : this.state.agency}
      //                 options={
      //                   [
      //                     { label: "Palette Interactive", value: "PALETTEINTERACTIVE" },
      //                     { label: "SRM Films", value: "SRMFILMS" },
      //                     { label: "Opporture", value: "OPPORTURE" },
      //                     { label: "Internal", value: "INTERNAL" }
      //                   ]
      //                 }
      //                 errors={["This field is required"]}
      //                 onChange={(value) => { this.setState({ agency: value }) }}
      //               />
      //             </Col>

      //           </div>

      //           <div className="row mb-4">
      //             <Label
      //               htmlFor="horizontal-password-Input"
      //               className="col-sm-3 col-form-label"
      //             >
      //               Password
      //             </Label>
      //             <Col sm={9}>
      //               <Input
      //                 type="password"
      //                 className="form-control"
      //                 id="horizontal-password-Input"
      //               />
      //             </Col>
      //           </div>

      //           <div className="row justify-content-end">
      //             <Col sm={9}>
      //               <div className="form-check mb-4">
      //                 <Input
      //                   type="checkbox"
      //                   className="form-check-Input"
      //                   id="horizontal-customCheck"
      //                 />
      //                 <Label
      //                   className="form-check-label"
      //                   htmlFor="horizontal-customCheck"
      //                 >
      //                   Remember me
      //                 </Label>
      //               </div>

      //               <div>
      //                 <Button
      //                   type="submit"
      //                   color="primary"
      //                   className="w-md"
      //                 >
      //                   Submit
      //                 </Button>
      //               </div>
      //             </Col>
      //           </div>
      //         </ValidatorForm>
      //       </CardBody>
      //     </Card>
      //   </Col>
      // </Row>
    )
  }

  // _onSubmit = ({ formData, errors }) => {
  //   if (errors) {
  //     return;
  //   }
  //   formData.creatorId = _.get(this.props, "data.userId") ? _.get(this.props, "data.userId") : '';
  //   formData.userStatus = formData.userStatus ? 1 : 0;
  //   formData.permissions = JSON.stringify(formData.permissions);
  //   this.props.onSubmit(formData)
  // }

  _onSubmit = formData => {
    const {
      includePermission = [],
      excludePermission = [],
      roles = [],
      email,
    } = this.state.formData

    formData.status = this.state.status ? 1 : 0
    //formData.roles = !_.isEmpty(roles) ? JSON.stringify(roles) : null

    //formData.email = formData.email.toLowerCase()

    const data = new FormData()
    // if (!_.isEmpty(formData.name)) {
    //     data.append("name", formData.name)
    // }
    data.append("status", this.state.status ? 1 : 0)
    // if (!_.isEmpty(formData.status)) {
    //   data.append("status", formData.status)
    // }
    // if (!_.isEmpty(formData.password)) {
    //     data.append("password", formData.password)
    // }
    if (!_.isEmpty(email)) {
      data.append("email", email.toLowerCase())
    }
    if (!_.isEmpty(includePermission)) {
      data.append("includePermission", JSON.stringify(includePermission))
    }
    if (!_.isEmpty(excludePermission)) {
      data.append("excludePermission", JSON.stringify(excludePermission))
    }
    if (!_.isEmpty(roles)) {
      data.append("roles", JSON.stringify(roles))
    }
    // Object.keys(this.state.formData).forEach(key => {
    //   if (
    //     this.state.formData[key] !== undefined &&
    //     this.state.formData[key] !== ""
    //   ) {
    //     data.append(key, this.state.formData[key])
    //   }
    // })
    // var data = _.omitBy(formData, _.isNil)
    // data.includePermission = !_.isEmpty(includePermission)
    //   ? JSON.stringify(includePermission)
    //   : JSON.stringify([])
    // data.excludePermission = !_.isEmpty(excludePermission)
    //   ? JSON.stringify(excludePermission)
    //   : JSON.stringify([])
    this.props.onSubmit(data)
  }

  _render = () => {
    return this._form()
  }
}
